import { useLinkLikeClick } from '../../../../../hooks'
import { formatNumberWithSeparators } from '../../../../../utils/number'
import { DashboardTile } from '../../../../DashboardBirdview'
import {
  checkIsOverviewKpiAbbreviated,
  getOverviewKpiCount,
} from '../RentalPortalOverviewKpiRow.utils'

function OverviewKpiTile({ kpi }) {
  const { handleClick: handleLinkClick } = useLinkLikeClick()

  function handleOpen(event) {
    handleLinkClick({ event, link: kpi.link })
  }

  return (
    <DashboardTile
      dragHandle
      Icon={kpi.Icon}
      count={getOverviewKpiCount(kpi.value)}
      countTooltip={
        checkIsOverviewKpiAbbreviated(kpi.value)
          ? formatNumberWithSeparators(kpi.value)
          : null
      }
      delta={kpi.delta}
      deltaTone={kpi.deltaTone}
      label={kpi.label}
      state={kpi.state}
      tone={kpi.tone}
      onClick={kpi.link ? handleOpen : null}
    />
  )
}

export default OverviewKpiTile
